import { LocationDetailConstants } from '../constants';

export function locateDetailReducer(state = {}, action) {
    switch (action.type) {
        case LocationDetailConstants.GETALL_LOC_DETAIL_REQUEST:
            return {
                loading: true
            };
        case LocationDetailConstants.GETALL_LOC_DETAIL_SUCCESS:
            return {
                items: action.locDetails
            };
        case LocationDetailConstants.GETALL_LOC_DETAIL_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}